export { default } from './FlexBox';
export type { Props } from './FlexBox';
